import request from '@/utils/request'

export function getGoodsStorageList(data) {
  return request.post('/goods-storage/list', data)
}

export function modifyGoodsStorage(data) {
  return request.post('/goods-storage/modify', data)
}



// WEBPACK FOOTER //
// ./src/api/stock/goods-storage.js